import React, { useEffect } from "react";
import { Card, Col, Container } from "reactstrap";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import _, { toString } from "lodash";
import { CommonText } from "components/Common/TextCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { CommonButton } from "components/Common/ButtonCommon";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { GET_KPI_CRITERIA } from "helpers/url_helper";
import httpService from "services/httpService";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrCRUDSuccess,
  toastrErrorAlert,
} from "components/Common/AlertToastr";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";
import InputField from "components/form-control/InputField";
import Spacer from "components/Common/Spacing";
import Table from "components/form-control/Table";
import SelectField from "components/form-control/Select";
import { formatNumber, parseNumber } from "helpers/erp_helper";
const ASSESS = [
  { index: 1, name: "Không đạt", value: "bad" },
  { index: 2, name: "Đạt", value: "good" },
  { index: 3, name: "Xuất sắc", value: "excellent" },
];
const HEADERS1 = [
  {
    text: "Mức đạt doanh số từ (%)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.rangeFrom`,
    }),
  },
  {
    text: "Mức đạt doanh số đến (%)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.rangeTo`,
    }),
  },
  {
    text: "% Hoa hồng (%) ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.commissionPercent`,
      type: "text",
    }),
  },
  {
    text: "Đánh giá",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.assess`,
      options: ASSESS,
    }),
  },
  {
    text: "Thưởng KPI (VNĐ)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.kpiBonus`,
      type: "text",
      onChange: e => {
        const { setValue } = formValue;
        setValue(
          `kpi_table.${indexOfRow}.kpiBonus`,
          formatNumber(e.target.value)
        );
      },
    }),
  },
];

const NewCriteria = () => {
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    getKpi();
  }, [id]);

  const schema = yup

    .object({
      name: yup.string().required("Trường này bắt buộc"),

      requiredSalesFrom: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Trường này bắt buộc")
          : yup
              .number()
              .typeError(`DS bắt buộc phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      requiredSalesTo: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Trường này bắt buộc")
          : yup
              .number()
              .typeError(`DS bắt buộc phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      duration: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Trường này bắt buộc")
          : yup
              .number()
              .typeError(`Thời gian áp dụng phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      pluralFrom: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Trường này bắt buộc")
          : yup
              .number()
              .typeError(`Mức đạt DS phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      pluralTo: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Trường này bắt buộc")
          : yup
              .number()
              .typeError(`Mức đạt DS phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),

      commissionPercent: yup.string().typeError(`% Hoa hồng phải là số!`),

      kpiBonus: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
          : yup
              .number()
              .typeError(`Thưởng KPI là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
    })

    .required();

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    defaultValues: { typeDuration: "month" },
    resolver: yupResolver(schema),
  });

  const { renderForm } = useGetFormSchema("Kpi", yup, rest, errors);

  const getKpi = async () => {
    if (!id) return;

    const res = await httpService.get(
      `${GET_KPI_CRITERIA}/${id}?include=["employeeGrade"]`
    );

    if (!res) {
      history.replace("/kpi");
      toastrErrorAlert("KPI not found!");
      return;
    }

    const { reset } = rest;

    reset({
      ...res,

      kpi_table:
        res?.attributes &&
        res?.attributes.map((item, index) => {
          return {
            rangeFrom: item.rangeFrom,
            rangeTo: item.rangeTo,
            commissionPercent: item.commissionPercent,
            kpiBonus: item.kpiBonus,
            assess: item.assess,
          };
        }),
      employeeGrade: res?.employeeGrade
        ? {
            text: res.employeeGrade?.name,
            objectId: res.employeeGrade.objectId,
            className: "EmployeeGrade",
            __type: "Pointer",
          }
        : { text: "" },
      requiredSalesFrom: formatNumber(res?.requiredSalesFrom),
      requiredSalesTo: formatNumber(res?.requiredSalesTo),
      kpiBonus: formatNumber(res?.kpiBonus),
    });
  };

  const onSubmit = async values => {
    const { setValue } = rest;
    const kpi = {
      name: values.name,

      requiredSalesFrom: Number(values.requiredSalesFrom),
      requiredSalesTo: Number(values.requiredSalesTo),
      employeeGrade: {
        objectId: values?.employeeGrade?.objectId,
        className: "EmployeeGrade",
        __type: "Pointer",
      },
      duration: Number(values.duration),
      typeDuration: values.typeDuration,
      isActive: values.isActive,
      attributes: values.kpi_table.map(item => ({
        ...item,
        rangeFrom: Number(item.rangeFrom),
        rangeTo: Number(item.rangeTo),
        commissionPercent: Number(item.commissionPercent),
        kpiBonus: parseNumber(item.kpiBonus),
        assess: toString(item.assess),
      })),
    };

    if (id) {
      try {
        const res = await httpService.put(GET_KPI_CRITERIA + `/${id}`, kpi);
        if (res?.updatedAt) {
          toastrCRUDSuccess("Kpi", TEXT_PUT);
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
      }
      return;
    }
    try {
      const res = await httpService.post(GET_KPI_CRITERIA, kpi);

      if (res?.createdAt) {
        toastrCRUDSuccess("Kpi", TEXT_POST);
        return;
      }
      toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi. Vui lòng thử lại sau!!");
    }
  };

  console.log("errors", errors);

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title="Thêm / Sửa Chỉ Tiêu KPI">
            <CommonButton level={0} type="submit">
              Save
            </CommonButton>
          </HeaderCreateItem>
          <Card body>
            <CommonText level={1} className="m-0">
              Thông tin mục tiêu
            </CommonText>
            {renderForm([])}
            <Col xs={12}>
              <div>
                <div className="d-flex flex-column justify-content-start align-items-start">
                  <CommonText
                    className="text-nowrap my-0"
                    level={1}
                    style={{ minWidth: "8rem" }}
                  >
                    Tham số
                  </CommonText>
                </div>
                <Spacer size={20} />

                <Table
                  headers={HEADERS1}
                  formProps={{
                    errors,
                    ...rest,
                  }}
                  name="kpi_table"
                />
              </div>
            </Col>
          </Card>
        </form>
      </Container>
    </div>
  );
};

export default NewCriteria;
